import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-info-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M8 5.1665V8.6665"
        [attr.stroke]="color() || '#EF4444'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
      <path
        d="M14.0538 5.72019V10.2802C14.0538 11.0268 13.6538 11.7202 13.0071 12.1002L9.04712 14.3869C8.40045 14.7602 7.60044 14.7602 6.9471 14.3869L2.9871 12.1002C2.34043 11.7269 1.94043 11.0335 1.94043 10.2802V5.72019C1.94043 4.97352 2.34043 4.28016 2.9871 3.90016L6.9471 1.6135C7.59377 1.24016 8.39379 1.24016 9.04712 1.6135L13.0071 3.90016C13.6538 4.28016 14.0538 4.96685 14.0538 5.72019Z"
        [attr.stroke]="color() || '#EF4444'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
      <path
        d="M8 10.7998V10.8665"
        [attr.stroke]="color() || '#EF4444'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none" />
    </svg>
  `,
})
export class InfoIconComponent extends BaseIconComponent {
  override width = input<string>('16');
  override height = input<string>('16');
  override viewBox = input<string>('0 0 16 16');
}
